import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-linkpage',
  templateUrl: './linkpage.component.html',
  styleUrls: ['./linkpage.component.css']
})
export class LinkpageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
